import { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import imgLogo from '../../assets/img/logo.svg'

import { Main } from './style'
import { Button } from '../../components/button'
import UsuarioService from '../../services/UsuarioService'
import api from '../../services/api'
import { setAuthenticated, setUsuario } from '../../provider/actions'
import { useProvider } from '../../provider/Provider'

const Login = () => {
    const history = useHistory()
    const { dispatch } = useProvider()
    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')

    function handleLogin() {
        UsuarioService.login(
            { username: email, password: senha }
        ).then((data) => {
            localStorage.setItem('token', data.token)
            api.defaults.headers.common.Authorization = `Token ${data.token}`
            setAuthenticated(dispatch, true)
            UsuarioService.get().then((user) => {
                setUsuario(dispatch, user)
            })
            history.push('/')
        }).catch(() => {
            swal({
                title: 'Dados inválidos!',
                icon: 'warning',
                buttons: [false],
                timer: 2000
            })
        })
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        handleLogin()
    }

    return (
        <Main>
            <form className="login" onSubmit={handleSubmit}>
                <img
                    src={imgLogo}
                    width="238"
                    height="45"
                    alt="Logo da Conectaê."
                />

                <div className="form-group">
                    <label htmlFor="idEmail">
                        E-mail:
                        <input
                            name="email"
                            type="text"
                            className="form-control"
                            id="idEmail"
                            autoComplete="off"
                            onChange={(event) => {
                                return setEmail(event.target.value)
                            }}
                            required
                        />
                    </label>
                </div>
                <div className="form-group">
                    <label htmlFor="idSenha">
                        Senha:
                        <input
                            name="password"
                            type="password"
                            className="form-control"
                            id="idSenha"
                            autoComplete="off"
                            onChange={(event) => {
                                return setSenha(event.target.value)
                            }}
                            required
                        />
                    </label>
                </div>
                <Button type="submit">
                    Entrar
                </Button>
                <Link to="/cadastrar-usuario">Cadastrar</Link>
            </form>
        </Main>
    )
}
export default Login
